export default {
    path : "land-item-all",
    name : "land-item-all",
    meta : {
        title : "全部项目"
    },
    component: () => import('@/pages/land/all/Index'),
    redirect: {
        name : "land-item-all-whole"
    },
    children: [
        {
            path: 'all',
            name: 'land-item-all-whole',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'land-item-all-recent',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'land-item-all-atme',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'land-item-all-meat',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'land-item-all-reply',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'land-item-all-search',
            meta: {
                title: '土地项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path : 'detail/:id',
            name : 'land-item-all-detail',
            metal: {
                title : '项目详细信息',
            },
            component: () => import('@/pages/itemCommon/Detail'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/land/allitem/index.js